import React from "react";
import { useSearchParams } from "react-router-dom";
import { TeamReportPage1, TeamReportPage2 } from "../../longball/team-report";

export const LongballTeamReportRender = () => {
  const [searchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") ?? "0", 10);

  const injected = (typeof window !== "undefined" && window.__TEAM_STATS__) || null;
  const data = injected || null;

  return (
    <>
      <style>{`
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          width: 900px !important;
          height: 900px !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }
      `}</style>
      <div data-export-ready="true" data-chart-container>
        {page === 0 ? <TeamReportPage1 data={data} /> : <TeamReportPage2 data={data} />}
      </div>
    </>
  );
};
